export default "__VITE_ASSET__BTE2$hzE__"